export default __webpack_public_path__ + "static/1344-133944c2e7b92ec8f9b0da4b8db148b7.gif";